module.exports = __webpack_public_path__ + "static/media/ils_covid_failed_copy_2.ac39b038.svg";